export function formatSingleDigit(digit: number) {
  return digit < 10 ? `0${digit}` : digit;
}
